// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","light":"Menu_light__p+Wqx","active":"Menu_active__-0Z9R","dark":"Menu_dark__YgM07"};